import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Row,
  Col
} from 'reactstrap';
import { onEnter, onExit } from "../../../../config/customModalFunctions";
import { Messages } from '../../../layout/Messages/Messages';
import { NOTIFICATION_REFUND_MODAL } from '../../../../config/notifications';
import { formatVatPercentage } from 'helpers/general';

function RefundModalComponent(props) {
  const [ timeConfirm, setTimeConfirm ] = useState( 60 );
  const [ disableConfirm, setDisableConfirm ] = useState( false );
  const { showModal, closeModal, refundOrderData } = props;

  // Disable button if there's nothing to refund
  const hasNoRefundableAmount = refundOrderData && refundOrderData.total === 0;

  useEffect( () => {
    let interval;
    if (timeConfirm > 0) {
      interval = setInterval( () => {
        setTimeConfirm( timeConfirm - 1 );
      }, 1000 );
    } else {
      setDisableConfirm( true );
    }

    return () => {
      clearInterval( interval );
    };
  }, [ timeConfirm ] );

  const getProductName = (item) => {
    let productGroupName = '';
    let productName = '';
    item.product.product_group.translations.forEach( translation => {
      if (translation.language.short_name === props.lang) {
        productGroupName = translation.name;
      }
    } );

    item.product.translations.forEach( translation => {
      if (translation.language.short_name === props.lang) {
        productName = translation.name;
      }
    } );

    return `${productGroupName} (${productName})`
  }

  const calculateSubTotalWithoutVat = (getNumeric) => {
    let subTotal = 0;

    refundOrderData.items.forEach( item => {
      subTotal = subTotal + item.total_without_vat;
    } );

    if (getNumeric) {
      return parseFloat( subTotal ).toFixed( 2 );
    } else {
      return `${parseFloat( subTotal ).toFixed( 2 )} ${refundOrderData.currency}`;
    }
  }

  const calculateVatSubTotal = (getNumeric) => {
    let subTotal = 0;
    refundOrderData.items.forEach( item => {
      subTotal = subTotal + item.vat;
    } );

    if (getNumeric) {
      return parseFloat( subTotal ).toFixed( 2 );
    } else {
      return `${parseFloat( subTotal ).toFixed( 2 )} ${refundOrderData.currency}`;
    }
  }

  const renderProducts = () => {
    return refundOrderData.items.map( (item, index) => {
      return <Row key={index} className="align-items-center refund-row">
        <Col xs={3}>{getProductName( item )}</Col>
        <Col>{`${item.price} ${refundOrderData.currency}`}</Col>
        <Col>{item.quantity}</Col>
        <Col>{`${item.total_without_vat.toFixed(2)} ${refundOrderData.currency}`}</Col>
        <Col>{`${item.vat.toFixed(2)} ${refundOrderData.currency}`}</Col>
        <Col>{`${item.total.toFixed(2)} ${refundOrderData.currency}`}</Col>
      </Row>
    } )
  }

  return (
    <Modal
      isOpen={showModal}
      toggle={closeModal}
      onEnter={onEnter}
      onExit={onExit}
      size="xl"
      fullscreen="xl"
      centered
    >
      <ModalHeader toggle={closeModal} className="refund-modal-title">
        <FormattedMessage
          id="components.pages.orderManagement.modals.title"/>
      </ModalHeader>
      <ModalBody>
        <Messages notificationId={NOTIFICATION_REFUND_MODAL}/>
        {! refundOrderData && <div>
          <FormattedMessage id="messages.no_data"/>
        </div>}
        <Row>
          <Col className="refund-modal-subtitle">
            <FormattedMessage id="components.pages.orderManagement.modals.sub_title"/>
          </Col>
        </Row>
        <div className="refund-table">
          <div className="refund-table__scroller">
            <div className="refund-table__grid">
              <Row className="refund-th">
                <Col xs={3}>
                  <FormattedMessage
                    id="components.pages.orderManagement.modals.refund.product"/>
                </Col>
                <Col>
                  <FormattedMessage
                    id="components.pages.orderManagement.modals.refund.unity_price"/>
                </Col>
                <Col>
                  <FormattedMessage
                    id="components.pages.orderManagement.modals.refund.quantity"/>
                </Col>
                <Col>
                  <FormattedMessage
                    id="components.pages.orderManagement.modals.refund.price_without_vat"/>
                </Col>
                <Col>
                  <FormattedMessage
                    id="components.pages.orderManagement.modals.refund.vat"/>({formatVatPercentage(refundOrderData.vat)}%)
                </Col>
                <Col>
                  <FormattedMessage
                    id="components.pages.orderManagement.modals.refund.price_with_vat"/>
                </Col>
              </Row>

              {renderProducts()}

              <Row className="refund-th">
                <Col xs={3}>
                  <FormattedMessage
                    id="components.pages.orderManagement.modals.refund.subtotal"/>
                </Col>
                <Col></Col>
                <Col></Col>
                <Col>{calculateSubTotalWithoutVat()}</Col>
                <Col>{calculateVatSubTotal()}</Col>
                <Col>{`${refundOrderData.total.toFixed(2)} ${refundOrderData.currency}`}</Col>
              </Row>
            </div>
          </div>
          <Row className="justify-content-end refund-table__total">
            <Col className="text-right">
            <span className="refund-total-price">
              <FormattedMessage
                id="components.pages.orderManagement.modals.refund.total"/>
              {`${refundOrderData.total.toFixed(2)} ${refundOrderData.currency}`}
            </span>
            </Col>
          </Row>
        </div>
        <div className="text-center text-sm-right py-3 mt-4">
          <Button className="mt-2 mt-sm-0" name="cancel" type="submit"
                  color="primary"
                  onClick={closeModal}>
            <FormattedMessage id="button.cancel"/>
          </Button>
          <Button
            className={`mt-2 mt-sm-0 ${(disableConfirm || hasNoRefundableAmount) ? 'custom-disable-btn' : ''}`}
            name="confirm" type="submit"
            color="primary"
            disabled={disableConfirm || hasNoRefundableAmount}
            onClick={() => props.confirmRefund( refundOrderData )}>
            <FormattedMessage id="button.confirm"/> {!hasNoRefundableAmount && `(${timeConfirm})`}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = state => ( {
  lang: state.locale.lang,
} )
const RefundModal = connect( mapStateToProps, null )( RefundModalComponent );

export { RefundModal, RefundModalComponent };
